const fs = require('fs')
const path = require('path')

export default class FileSystemCache {
  constructor (options = {}) {
    this.ttl = options.ttl || 0
    this.basePath = options.basePath || './cache'

    this.ensureBasePathExists()
  }

  buildPath (key) {
    return path.resolve(this.basePath, `${key}.json`)
  }

  encode (content) {
    return JSON.stringify({
      content,
      expires: this.ttl === 0 ? false : (new Date()).valueOf() + this.ttl
    })
  }

  decode (body) {
    return JSON.parse(body)
  }

  ensureBasePathExists () {
    try {
      fs.mkdirSync(path.resolve(this.basePath))
    } catch (error) {
      /* do nothing */
    }
  }
  
  async set (key, content) {
    return await fs.promises.writeFile(
      this.buildPath(key),
      this.encode(content)
    )
  }

  async get (key) {
    try {
      const encodedBody = await fs.promises.readFile(
        this.buildPath(key)
      )
      const body = this.decode(encodedBody)
      if (!body) return null
      if (body.expires && body.expires < (new Date()).valueOf()) return null
      return body.content
    } catch (error) {
      /* do nothing */
    }
  }
}